import SOCIAL_LINKS from "config/socials";
import { getParentLanguage } from "../localeUtils";

const twitterUrl = "https://twitter.com/";

const buildTwitterUsername = (url: string) => url.replace(twitterUrl, "@");

const getSocials = (language: string) => {
  const socialLinks = SOCIAL_LINKS[language] ? SOCIAL_LINKS[language] : SOCIAL_LINKS[getParentLanguage(language)];

  if (!socialLinks) return SOCIAL_LINKS.fallback;

  return socialLinks;
};

export const getTwitterUsername = (language: string) => buildTwitterUsername(getSocials(language).twitter.url);

export const getSocialLink = (language: string, socialPlatform: string) => getSocials(language)[socialPlatform].url;
